import { render } from "./CuentaBancoForm.vue?vue&type=template&id=712eef06&scoped=true"
import script from "./CuentaBancoForm.vue?vue&type=script&lang=js"
export * from "./CuentaBancoForm.vue?vue&type=script&lang=js"

import "./CuentaBancoForm.vue?vue&type=style&index=0&id=712eef06&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-712eef06"]])

export default __exports__